import _classCallCheck from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var Service = /*#__PURE__*/function () {
  function Service() {
    _classCallCheck(this, Service);
    this.framework = {};
  }
  _createClass(Service, [{
    key: "init",
    value: function init(root, ssrContext) {}
  }]);
  return Service;
}();